import React, { Component } from 'react';

import ProductList from '../components/productList/ProductList';
import AboutUsCardSet from '../components/aboudUsCards/AboutUsCardSet';
import ResponsiveCaraosel from '../components/caraousal/ResponsiveCaraosel';
import ProductSlider from '../components/productSlider/ProductSlider';
import prod from '../Products';

class HomePage extends Component {
    render() {
        return (
            <div className="container">
                <ResponsiveCaraosel />                
                <br /><br />
                <ProductSlider />
                <br /><br />
                <ProductList prod={prod} />
                <br /><br />
                <AboutUsCardSet />
            </div>
        );
    }
}

export default HomePage;
